import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrdersSummary  {
    _originalTypeClassName = "ekylikeio.BO.OrdersSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrdersSummary.translate = translateService;
}
this.Items = [];
this.OrdersSummaryKey = null;
this._key = this.OrdersSummaryKey = 0; 
}

static translate: TranslateService;
_key: any;
Items:any;
private _OrdersSummaryKey:any;
get OrdersSummaryKey(): any {
    return this._OrdersSummaryKey;
  }
set OrdersSummaryKey(value: any) {
    this._OrdersSummaryKey = value;
    this._key = value;
  }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.OrdersSummary.removeItems($this, $this.Items[0]);
                }

                Domain.OrdersSummary.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrdersSummary.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrdersSummary.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrdersSummaryKey == null || $this.OrdersSummaryKey == 0;
            }


}